import {
  ApiResponse,
  NetPriceCeilingGrouped,
  CreateDiscount,
  TokenData,
  CashDiscount,
  OtpResponse,
  CreateDiscountLimits,
  CreateNetPriceCeiling,
  NetPriceCeiling,
  UpdateNetPriceCeiling,
  CreateCampaignDiscountGroup,
  CampaignNpcDiscount,
  CreateCampaignNetPriceCeiling,
  UpdateCampaignNetPriceCeiling,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class CampaignNPCDiscountService extends ApiService {
  public async loadNetPriceCeiling() {
    const url = `${this.apiDomain}/api/vehicle/net-price-ceiling/list`;

    const resposne = await http.get<ApiResponse<NetPriceCeilingGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async create(data: any, id?: string) {
    const url = `${this.apiDomain}/api/campaign/${id}/add-discount`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      { ...data, discountType: 'NPC' },
      this.store
    );
    return response.data;
  }

  public async updateDiscount(data: any, id?: string) {
    const url = `${this.apiDomain}/api/campaign/${id}/update-add-discount`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      { ...data, discountType: 'NPC' },
      this.store
    );
    return response.data;
  }

  public async getNpcDiscount(id: string) {
    const url = `${this.apiDomain}/api/campaign/npc/${id}`;

    const resposne = await http.get<ApiResponse<CampaignNpcDiscount>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async update(data: CreateCampaignDiscountGroup, id: string) {
    const url = `${this.apiDomain}/api/vehicle/net-price-ceiling/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async updateVehicleNPC(
    data: UpdateCampaignNetPriceCeiling,
    id: string
  ) {
    const url = `${this.apiDomain}/api/campaign/edit/${id}/npc`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async get(id: string) {
    const url = `${this.apiDomain}/api/campaign/npc/${id}`;

    const resposne = await http.get<ApiResponse<NetPriceCeiling>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async deleteDiscount(id?: string) {
    const url = `${this.apiDomain}/api/campaign/npc/${id}`;
    const response = await http.remove<ApiResponse<CampaignNpcDiscount>>(
      url,
      this.store
    );
    return response?.data?.data;
  }
}
